var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.surgery)?_c('surg-add',{attrs:{"editSurgery":_vm.surgery}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }